import React, { useEffect, useRef, useState } from 'react';
import { getData, resolveImage } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import QRCode from 'react-qr-code';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import EventsScreen from './events';
import DetailProduct from './DetailProduct';
import { useSelector } from 'react-redux';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import LunchSpecial from './lunchspecial';
import CoffeShop from './coffeShop';

import { isLocalMirror } from '../../config/constants';
const ACCENT = '#ED3E08';
const SLIDE_MS = 4500;

// Promos del welcome: se cargan solas desde ./assets/carrousel (orden alfabetico del archivo)
const slidesContext = require.context('./assets/carrousel', false, /\.(png|jpe?g|webp)$/);
const SLIDES = slidesContext.keys().sort().map((key) => slidesContext(key));

const WELCOME_CSS = `
@keyframes welcomePulseGlow {
    0%, 100% { box-shadow: 0 0 0 0 rgba(237, 62, 8, 0.55), 0 0 18px 3px rgba(237, 62, 8, 0.45); }
    50% { box-shadow: 0 0 0 11px rgba(237, 62, 8, 0), 0 0 32px 7px rgba(237, 62, 8, 0.75); }
}
@keyframes welcomeShine {
    0% { transform: translateX(-120%) skewX(-20deg); }
    60%, 100% { transform: translateX(240%) skewX(-20deg); }
}
`;

function WelcomeCarousel({ onEnter, langEng }) {
    const [index, setIndex] = useState(0);
    const touchStart = useRef(null);
    const swiped = useRef(false);

    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prev) => (prev + 1) % SLIDES.length);
        }, SLIDE_MS);

        return () => clearInterval(timer);
    }, [index]);

    const goTo = (e, next) => {
        e.stopPropagation();
        setIndex(next);
    };

    const onTouchStart = (e) => {
        swiped.current = false;
        touchStart.current = e.touches[0].clientX;
    };

    const onTouchEnd = (e) => {
        if (touchStart.current === null) return;
        const delta = e.changedTouches[0].clientX - touchStart.current;
        touchStart.current = null;

        if (Math.abs(delta) < 40) return;

        swiped.current = true;
        setIndex((prev) => (prev + (delta < 0 ? 1 : SLIDES.length - 1)) % SLIDES.length);
    };

    return (
        <div
            onClick={() => {
                if (swiped.current) {
                    swiped.current = false;
                    return;
                }
                onEnter();
            }}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 99999,
                background: '#000',
                overflow: 'hidden',
                cursor: 'pointer',
                userSelect: 'none',
                WebkitTapHighlightColor: 'transparent'
            }}
        >
            <style>{WELCOME_CSS}</style>

            {/* Sliders a pantalla completa con cross-fade */}
            {SLIDES.map((src, i) => (
                <div
                    key={i}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: i === index ? 1 : 0,
                        transition: 'opacity 900ms ease-in-out',
                        pointerEvents: 'none'
                    }}
                >
                    <img
                        src={src}
                        alt={`promo-${i + 1}`}
                        onContextMenu={(e) => e.preventDefault()}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                            display: 'block'
                        }}
                    />
                </div>
            ))}

            {/* Degradado inferior para legibilidad del boton */}
            <div
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(to bottom, rgba(0,0,0,0.18) 0%, transparent 35%, rgba(0,0,0,0.55) 78%, rgba(0,0,0,0.9) 100%)',
                    pointerEvents: 'none'
                }}
            />

            {/* Indicadores + boton luminoso */}
            <div
                style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 26,
                    padding: '0 24px 8vh'
                }}
            >
                <div style={{ display: SLIDES.length > 1 ? 'flex' : 'none', gap: 10 }}>
                    {SLIDES.map((_, i) => (
                        <div
                            key={i}
                            onClick={(e) => goTo(e, i)}
                            style={{
                                width: i === index ? 30 : 10,
                                height: 10,
                                borderRadius: 6,
                                background: i === index ? ACCENT : 'rgba(255,255,255,0.45)',
                                boxShadow: i === index ? '0 0 12px 2px rgba(237,62,8,0.7)' : 'none',
                                transition: 'all 350ms ease',
                                cursor: 'pointer'
                            }}
                        />
                    ))}
                </div>

                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onEnter();
                    }}
                    style={{
                        position: 'relative',
                        overflow: 'hidden',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 9,
                        padding: '12px 26px',
                        border: '1.5px solid rgba(255,255,255,0.35)',
                        borderRadius: 999,
                        background: `linear-gradient(135deg, ${ACCENT} 0%, #C70100 100%)`,
                        color: '#fff',
                        fontSize: 16,
                        fontWeight: 900,
                        letterSpacing: '0.02em',
                        textTransform: 'uppercase',
                        cursor: 'pointer',
                        animation: 'welcomePulseGlow 1.8s ease-in-out infinite',
                        WebkitTapHighlightColor: 'transparent'
                    }}
                >
                    <span style={{ position: 'relative', zIndex: 2 }}>
                        {langEng ? 'Tap to view menu' : 'Toca para ver el menú'}
                    </span>
                    <span style={{ position: 'relative', zIndex: 2, opacity: 0.6, fontWeight: 400 }}>/</span>
                    <span style={{ position: 'relative', zIndex: 2, fontSize: 13, opacity: 0.9 }}>
                        {langEng ? 'Toca para ver el menú' : 'Tap to view menu'}
                    </span>

                    {/* Brillo que recorre el boton */}
                    <span
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '35%',
                            height: '100%',
                            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.55), transparent)',
                            animation: 'welcomeShine 2.8s ease-in-out infinite',
                            pointerEvents: 'none',
                            zIndex: 1
                        }}
                    />
                </button>
            </div>
        </div>
    );
}

// Botones de categoria del home (columna derecha). `match` busca la categoria del
// menu por nombre (ES/EN); `action: 'drinks'` abre la pantalla de bebidas si no
// existe una categoria que coincida.
const CATEGORY_BUTTONS = [
    { key: 'food-menu', match: ['FOOD MENU', 'MAIN', 'PLATOS', 'FUERTE'] },
    { key: 'bbq', match: ['BBQ', 'PARRILLA', 'GRILL'] },
    { key: 'appetizers', match: ['APPETIZER', 'ENTRADA', 'ANTOJITO'] },
    { key: 'salads', match: ['SALAD', 'ENSALADA'] },
    { key: 'seafood', match: ['SEAFOOD', 'MARISCO'] },
    { key: 'tacos', match: ['TACO'] },
    { key: 'sides', match: ['SIDE', 'ACOMPA'] },
    { key: 'kids-menu', match: ['KIDS', 'NIÑOS', 'NINOS'] },
    { key: 'drinks', match: ['DRINK', 'BEBIDA'], action: 'drinks' },
    { key: 'desserts', match: ['DESSERT', 'POSTRE'] }
];

const buttonImages = require.context('./assets/home/botones', false, /\.png$/);

const findCategory = (menus, { match = [], id }) => {
    const byName = menus.find((item) => {
        const names = [item.name, ...(item.language || []).map((lang) => lang.name)]
            .filter(Boolean)
            .map((name) => name.toUpperCase());
        return names.some((name) => match.some((word) => name.includes(word)));
    });
    return byName || menus.find((item) => item.id === id) || null;
};

// Header del home: redes a la izquierda, logo al centro y selector EN/ES a la derecha
function HeaderBanner({ langEng, socials, onSocial }) {
    const langOption = (code, label, flag) => {
        const active = (code === 'en') === langEng;

        return (
            <div
                onClick={() => i18next.changeLanguage(code)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '6px 10px',
                    borderRadius: 7,
                    background: active ? '#fff' : 'transparent',
                    color: active ? '#000' : '#fff',
                    fontSize: 'clamp(16px, 2.4vw, 30px)',
                    fontWeight: 500,
                    lineHeight: 1,
                    cursor: 'pointer',
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent'
                }}
            >
                <img src={flag} alt={label} style={{ width: '1em', height: '1em', borderRadius: '50%', objectFit: 'cover' }} />
                {label}
            </div>
        );
    };

    const socialStyle = { width: 'clamp(32px, 4.3vw, 56px)', height: 'auto', cursor: 'pointer' };

    return (
        <div
            style={{
                background: '#000',
                borderRadius: '0 0 28px 28px',
                height: '15vh',
                minHeight: 120,
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                padding: '0 5%'
            }}
        >
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '3vw' }}>
                <img
                    src={require('./assets/home/facebook.png')}
                    alt="Facebook"
                    style={socialStyle}
                    onClick={() => socials.facebook && onSocial(socials.facebook)}
                />
                <img
                    src={require('./assets/home/instagram.png')}
                    alt="Instagram"
                    style={socialStyle}
                    onClick={() => socials.instagram && onSocial(socials.instagram)}
                />
            </div>

            <img
                src={require('./assets/home/logo.png')}
                alt="Habaneros"
                style={{ height: '82%', width: 'auto', objectFit: 'contain', pointerEvents: 'none' }}
            />

            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ display: 'flex', border: '2px solid #fff', borderRadius: 10, padding: 2 }}>
                    {langOption('en', 'EN', require('../../assets/icons/english.png'))}
                    {langOption('es', 'ES', require('../../assets/icons/spanish.png'))}
                </div>
            </div>
        </div>
    );
}


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);
    const [socials, setSocials] = useState({});
    const [qrUrl, setQrUrl] = useState(false);
    const [showWelcome, setShowWelcome] = useState(SLIDES.length > 0);
    const [dataDish, setDataDish] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);
    const [showEvents, setShowEvents] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [desserts, setdesserts] = useState(false);
    const [showDrinks, setShowDrinks] = useState(false);
    const [showLunchSpecial, setShowLunchSpecial] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [cocina, setcolombiana] = useState(false);
    const [pescadomarico, setpescadomarico] = useState(false);
    const [fuertes, setfuertes] = useState(false);
    const [antojitos, setantojitos] = useState(false);
    const [desayuno, setdesayuno] = useState(false);
    const [picada, setpicada] = useState(false);
    const [entrada, setentrada] = useState(false);
    const [coffe, setcoffe] = useState(false);
    const [cocktail, setcocktail] = useState(false);
    const [pastas, setpastas] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [showCoffe, setshowCoffe] = useState(false);
    
   

    const fetchImage = async (id) => {
        return resolveImage(id);
    };


         const {
           goHomeInit
         } = useSelector((state) => state.initLoad);
        
    
        
    

    useEffect(() => {
        getData('menu').then((items) => {
            // Sin menu en disco todavia: no reventar la app entera.
            if (!items?.value?.data) return;
            const data = items.value.data;
           
            setMenus(data);
            setSocials(items.value.socials || {});
        });
    }, [change]);

    useEffect(() => {
        menus.map((item) => {
            if (item.id === 906) {
                setdesserts(item);
            }

            if (item.id === 897) {
                setcolombiana(item);
            }
            if (item.id === 900) {
                setpescadomarico(item);
            }

            if (item.id === 898) {
                setfuertes(item);
            }

            if (item.id === 895) {
                setantojitos(item);
            }

            if (item.id === 894) {
                setdesayuno(item);
            }

            if (item.id === 896) {
                setpicada(item);
            }

            if (item.id === 905) {
                setentrada(item);
            }
             if (item.id === 907) {
                setcoffe(item);
             }
            
            if (item.id === 902) {
                setcocktail(item);
            }
            if (item.id === 899) {
                setpastas(item);
            }
            if (item.id === 901) {
                setdrinks(item);
            }


            if (item.id === 902) {
                setBeverages(item)
            }



        });
    }, [menus]);


    const GoBeverages = () => {
        setShowListProduct(true);
        setdishs(Beverages);
    }

    const openCategory = (key) => {
        const button = CATEGORY_BUTTONS.find((item) => item.key === key);
        const category = findCategory(menus, button);
        if (category) {
            setdishs(category);
            setShowListProduct(true);
        } else if (button.action === 'drinks') {
            setShowDrinks(true);
        }
    }

    const bannerStyle = {
        width: '100%',
        height: 'auto',
        display: 'block',
        cursor: 'pointer',
        userSelect: 'none',
        WebkitTapHighlightColor: 'transparent'
    };


    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
          
          
           setShowLunchSpecial(false)
          
            setshowCategories(false)
            setShowDetailProduct(false)
            setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)

            getInitData()
        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);


      useEffect(() => {
     
                setShowListProduct(false);
            setShowSpecials(false)
          
           
           setShowLunchSpecial(false)
          
            setshowCategories(false)
          setShowDetailProduct(false)
           setShowCocktails(false)
            setShowEvents(false)
            setShowDrinks(false)
         }, [goHomeInit]);

    window.onerror = function () {
        // En el kiosko NO se recarga a ciegas: el ErrorBoundary ya se recupera
        // solo, y recargar ante cualquier error suelto provocaba refrescos
        // sorpresa a los pocos segundos de abrir el menu.
        console.log('[Kiosko] Error global detectado');
        if (!isLocalMirror) {
            setTimeout(() => { window.location.reload(); }, 2000);
        }
        };

        
    

    return (
          <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            {showWelcome && (
                <WelcomeCarousel
                    langEng={langEng}
                    onEnter={() => setShowWelcome(false)}
                />
            )}

            <LayoutContent goCategories={() => {
               setShowDrinks(true)
        }} showBack={false} showLogo={false} showLang={false} showFooter={false} showCocktails={ GoBeverages} showEvents={ setShowEvents} showImageTop={true} setShowSpecials={setShowSpecials}>
                <div
                    onContextMenu={(e) => e.preventDefault()}
                    style={{ position: 'fixed', inset: 0, zIndex: 1, display: 'flex', background: '#f2f2f2' }}
                >
                    {/* Columna izquierda: header + banners */}
                    <div
                        style={{
                            width: '71%',
                            height: '100%',
                            overflowY: 'auto',
                            boxSizing: 'border-box',
                            padding: '0 2% 1.5vh',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            gap: '2vh',
                            backgroundImage: `url(${require('./assets/home/background.png')})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    >
                        <HeaderBanner langEng={langEng} socials={socials} onSocial={setQrUrl} />

                        <img src={require('./assets/home/banner-molcajete.png')} alt="Molcajete" style={bannerStyle} onClick={() => openCategory('food-menu')} />

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '3.5%' }}>
                            <img src={require('./assets/home/banner-bebidas.png')} alt="Bebidas frías" style={bannerStyle} onClick={() => openCategory('drinks')} />
                            <img src={require('./assets/home/banner-sunday.png')} alt="The Flag Sunday" style={bannerStyle} onClick={() => openCategory('desserts')} />
                            <img src={require('./assets/home/banner-delivery.png')} alt="Delivery" style={{ ...bannerStyle, cursor: 'default' }} />
                        </div>

                        <img src={require('./assets/home/banner-cocteles.png')} alt="Variedad de cócteles" style={bannerStyle} onClick={() => setShowDrinks(true)} />

                        <p
                            style={{
                                margin: 0,
                                textAlign: 'center',
                                fontFamily: 'Noodle',
                                fontSize: 'clamp(14px, 1.6vw, 22px)',
                                letterSpacing: 0.5,
                                color: '#000',
                                textTransform: 'uppercase'
                            }}
                        >
                            {langEng
                                ? '"Please inform the waiter if you have any type of allergic condition.'
                                : '"Por favor informe al mesero si tiene algún tipo de condición alérgica.'}
                        </p>
                    </div>

                    {/* Columna derecha: botones de categorias */}
                    <div
                        style={{
                            width: '29%',
                            height: '100%',
                            boxSizing: 'border-box',
                            padding: '3.5vh 0 2vh',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            backgroundColor: '#111',
                            backgroundImage: `url(${require('./assets/home/background-categorias.png')})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                        }}
                    >
                        <img src={require('./assets/home/menu-title.png')} alt="Menu" style={{ width: '78%', height: 'auto', flexShrink: 0, pointerEvents: 'none' }} />

                        <div style={{ flex: 1, minHeight: 0, width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly' }}>
                            {CATEGORY_BUTTONS.map((button) => (
                                <img
                                    key={button.key}
                                    src={buttonImages(`./${button.key}.png`)}
                                    alt={button.key}
                                    onClick={() => openCategory(button.key)}
                                    style={{
                                        width: '70%',
                                        maxHeight: '9.5%',
                                        objectFit: 'contain',
                                        cursor: 'pointer',
                                        WebkitTapHighlightColor: 'transparent'
                                    }}
                                />
                            ))}
                        </div>
                    </div>
                </div>

                {qrUrl && <div onClick={() => setQrUrl(false)} style={{ position: 'fixed', inset: 0, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#00000063', zIndex: 9999 }}>
                    <QRCode size={256} style={{ height: 400, width: 400 }} value={qrUrl} />
                </div>}

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}
            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}

                {showLunchSpecial && <LunchSpecial setShowHappy={setShowLunchSpecial} />}
                
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showEvents && <EventsScreen setShowHappy={setShowEvents} />}  
                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                 {showCoffe && <CoffeShop setShowHappy={setshowCoffe} />}  
                 {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={()=>setShowDetailProduct(false)}
                    setShowDetailProduct={setShowDetailProduct}
                />}
                

            </LayoutContent>
            </div>
    );
}

export default Index;